var parent = require('../../stable/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/instance/index-of.js
// module id = 3505
// module chunks = 25